import { render } from "./SectionPriceWelcome.vue?vue&type=template&id=7b434ab2&scoped=true"
import script from "./SectionPriceWelcome.vue?vue&type=script&lang=js"
export * from "./SectionPriceWelcome.vue?vue&type=script&lang=js"

import "./SectionPriceWelcome.vue?vue&type=style&index=0&id=7b434ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b434ab2"]])

export default __exports__